export enum StatisticRootKey {
  Statistics = 'statistics',
  Record = 'record',
  Opponents = 'opponents',
}
